import { __extends } from "tslib";
import { GestureEvent } from './GestureEvent';
var PressAndTapGestureEvent = /** @class */ (function (_super) {
    __extends(PressAndTapGestureEvent, _super);
    function PressAndTapGestureEvent(type, bubbles, cancelable, phase, localX, localY, tapLocalX, tapLocalY, ctrlKey, altKey, shiftKey) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (phase === void 0) { phase = null; }
        if (localX === void 0) { localX = 0; }
        if (localY === void 0) { localY = 0; }
        if (tapLocalX === void 0) { tapLocalX = 0; }
        if (tapLocalY === void 0) { tapLocalY = 0; }
        if (ctrlKey === void 0) { ctrlKey = false; }
        if (altKey === void 0) { altKey = false; }
        if (shiftKey === void 0) { shiftKey = false; }
        var _this = _super.call(this, type, bubbles, cancelable, phase, localX, localY, ctrlKey, altKey, shiftKey) || this;
        _this.tapLocalX = +tapLocalX;
        _this.tapLocalY = +tapLocalY;
        return _this;
    }
    PressAndTapGestureEvent.classInitializer = null;
    PressAndTapGestureEvent.classSymbols = null;
    PressAndTapGestureEvent.instanceSymbols = null;
    // JS -> AS Bindings
    PressAndTapGestureEvent.GESTURE_PRESS_AND_TAP = 'gesturePressAndTap';
    return PressAndTapGestureEvent;
}(GestureEvent));
export { PressAndTapGestureEvent };
